import { styled } from 'stitches.config'

export const HeroRoot = styled('div', {
  maxWidth: '$max',
  padding: '$3 $2',
  flex: 1,

  '@bp2': {
    paddingBottom: 0,
  },

  '@bp3': {
    padding: '$7 $9 0',
  },
  '.cta': {
    display: 'none',

    '@bp2': {
      cursor: 'pointer',
      display: 'inline-flex',
      marginTop: '$2',
    },
  },
})

export const HeroContent = styled('div', {
  '@bp2': {
    order: 1,
    paddingLeft: '$8',
  },

  '@bp3': {
    paddingLeft: '$11',
  },
})

export const ImageAndBadgeWrapper = styled('div', {
  alignSelf: 'center',
  position: 'relative',
  flex: 1,
  width: '275px',

  '@bp2': {
    width: '563px',
  },
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  maxWidth: '336px',

  '@bp1': {
    width: '480px',
    maxWidth: 'initial',
  },

  '@bp2': {
    width: '563px',
  },
})

export const BadgeContainer = styled('div', {
  position: 'absolute',
  color: '$primary-500',

  right: '0',
  bottom: '-28px',
  size: '112px',

  '@bp2': {
    size: '136px',
    right: '-16px',
    bottom: '-16px',
  },
})
